import { useContext } from "react";
import { message } from "antd";
import { LibraryCreativesContext } from "../../../../core/components/creatives/library/LibraryCreativesProvider";

export const useRemoveAdUnitsFromGroup = () => {
  const { updateAdGroupCreatives } = useContext(LibraryCreativesContext);

  const removeAdUnits = async (adGroup, mediaIdsToRemove) => {
    if (!adGroup) {
      message.error("Ad group data is missing.");
      return;
    }
    
    if (!adGroup.id) {
      message.error("Ad group ID is missing.");
      return;
    }
    
    if (!adGroup.medias) {
      message.error("No medias found in ad group.");
      return;
    }
    
    if (!mediaIdsToRemove || mediaIdsToRemove.length === 0) {
      message.error("No media selected for removal.");
      return;
    }

    try {
      await updateAdGroupCreatives({
        variables: {
          id: adGroup.id,
          data: {
            medias: {
              disconnect: mediaIdsToRemove.map(id => ({ id })),
            },
          },
        },
      });
    } catch (err) {
      message.error("Failed to remove Ad Unit(s) from group.");
      throw err; // Re-throw so the calling component can handle it
    }
  };

  return { removeAdUnits };
};
